import { lazy } from "react";
import { URLS } from "@/constants/urls";
import { createBrowserRouter, Navigate } from "react-router";

const MainLayout = lazy(() => import("../layouts/MainLayout/MainLayout.tsx"));
const Home = lazy(() => import("../pages/Home/Home.tsx"));
const Product = lazy(() => import("../pages/Product/Product.tsx"));
const Join = lazy(() => import("../pages/Join/Join.tsx"));
const RedirectToDownload = lazy(
  () => import("../pages/RedirectToDownload/RedirectToDownload.tsx")
);

const DashboardLayout = lazy(
  () => import("../layouts/DashboardLayout/index.tsx")
);
const AuthRoute = lazy(() => import("../pages/Auth/AuthRoute/AuthRoute.tsx"));
const JobsDashboard = lazy(() => import("../pages/Dashboard/index.tsx"));
const EditJob = lazy(() => import("../pages/Dashboard/EditJob/EditJob.tsx"));
const CreateJob = lazy(
  () => import("../pages/Dashboard/CreateJob/CreateJob.tsx")
);

const AuthLayout = lazy(() => import("../layouts/AuthLayout/index.tsx"));
const SignUp = lazy(() => import("../pages/Auth/SignUp/SignUp.tsx"));
const Login = lazy(() => import("../pages/Auth/Login/Login.tsx"));

const NotFound = lazy(() => import("../pages/NotFound/NotFound.tsx"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: URLS.home, index: true, element: <Home /> },
      { path: URLS.product, element: <Product /> },
      { path: URLS.joinUs, element: <Join /> },
      {
        path: URLS.redirectToDownload,
        element: <RedirectToDownload />,
      },
    ],
  },
  {
    path: "/",
    element: <AuthRoute />,
    children: [
      {
        path: URLS.Jobs,
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={URLS.JobsDashboard} replace />,
          },
          {
            path: URLS.JobsDashboard,
            element: <JobsDashboard />,
          },
          {
            path: URLS.JobsCreate,
            element: <CreateJob />,
          },
          {
            path: URLS.JobsEdit,
            element: <EditJob />,
          },
        ],
      },
      {
        path: URLS.Auth,
        element: <AuthLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={URLS.Login} replace />,
          },
          {
            path: URLS.SignUp,
            element: <SignUp />,
          },
          {
            path: URLS.Login,
            element: <Login />,
          },
        ],
      },
    ],
  },
  { path: "*", element: <NotFound /> },
]);

export default router;
